import { UserRoles, userRolesToLabelMap } from '@bb/users';
import React from 'react';
import { Tag } from 'components';
import styled from 'styled-components';

type RoleTagProps = {
  role: UserRoles;
};

const roleColorMap: Record<UserRoles, string> = {
  NON_MEMBER: 'blue',
  AGENT: 'blue',
  TEAM_ADMIN: 'blue',
  BRANCH_ADMIN: 'blue',
  GLOBAL_ADMIN: 'blue',
  MANAGER: 'blue',
  OWNER: 'blue',
};

const RoleTag: React.FC<RoleTagProps> = ({ role }) => (
    <StyledTag color={roleColorMap[role]}>
      {userRolesToLabelMap[role]}
    </StyledTag>
  );

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default RoleTag;
